import "./UploadVideoFile.scss"
import {LinearProgress} from "@mui/material";
import React, {useRef, useState} from "react";
import {css} from "@emotion/css";
import {FileManagerService} from "../../../component/fileManager/FileManagerService";
import {FileManagerTypes} from "../../../component/fileManager/FileManager";
import {
    RaikoAlert,
    raikoAlertTypes,
    RaikoButtonPrimary,
    RaikoButtonSecondary,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    showErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import ReactPlayer from "react-player";
import {useRaikoUploadManager} from "../../../raikoComponents/raikoUploader/RaikoUploadManagerContext";
import {RaikoUploadFileTypes} from "../../../raikoComponents/raikoUploader/RaikoUploadFileTypes";

export default function UploadVideoFile(
    {
        handleRefreshList,
        handleCloseDialog,
    }
) {

    const service = new FileManagerService()

    const [showUploadLoading, setShowUploadLoading] = useState(false)

    const [uploadPercent, setUploadPercent] = useState(0);
    const [videoFile, setVideoFile] = useState();

    const [videoFileName, setVideoFileName] = useState("")

    const uploadVideoFileRef = useRef();

    function uploadVideoFile({target: {files}}) {

        if (typeof files[0] !== 'undefined') {
            setVideoFile(files[0])
            setVideoFileName(files[0].name)
        }

    }

    function handleSelectVideoFile() {
        uploadVideoFileRef.current.click()
    }

    function handleHideLoading() {
        setUploadPercent(0)
    }

    const {startUpload} = useRaikoUploadManager()


    function handleUploadVideo() {

        startUpload(
            videoFile,
            service.uploadVideo,
            FileManagerTypes.VIDEO.uploadUrl,
            RaikoUploadFileTypes.VIDEO
        )

        handleCloseDialog()


       /* setShowUploadLoading(true)

        service.uploadVideoToServer(
            videoFile,
            setUploadPercent,
            handleHideLoading,
            FileManagerTypes.VIDEO.uploadUrl
        ).then(response => {
            setVideoFile(null)
            setVideoFileName("")
            showSuccessMessage("ویدیو جدید با موفقیت بارگزاری شد.")
            handleRefreshList(response)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setShowUploadLoading(false)
        })*/
    }

    return (
        <div className={"baseUploadVideoFileContainer"}>
            {
                videoFile ?
                    <RaikoGridOneColumn className={css`border-radius: .5rem;overflow: hidden;`}>
                        {/*<VideoPlayer file={videoFile} name={videoFileName}/>*/}
                        <ReactPlayer url={URL.createObjectURL(videoFile)} controls/>
                    </RaikoGridOneColumn> :
                    <RaikoAlert
                        type={raikoAlertTypes.info}
                        title={"بارگزاری ویدیو جدید"}
                        description={[
                            "* تنها فرمت قابل پذیرش mp4 می باشد.",
                            "",
                        ]}
                        className={css`width: 100%`}
                    />
            }

            {
                showUploadLoading ?
                    <div className={`loadingContainer ${css`width: 100%;`}`}>
                        <div className={css`
                          display: grid;
                          gap: .75rem;`
                        }>
                            <span className={"loadingHintTitle"}> ({uploadPercent + "%"}) در حال بارگزاری ویدیو جدید، لطفا صبور باشید...</span>
                            <LinearProgress
                                hidden={false}
                                variant="buffer"
                                value={uploadPercent}
                                valueBuffer={0}
                            />
                        </div>

                    </div> : ""
            }


            <input
                ref={uploadVideoFileRef}
                type="file"
                hidden
                accept="video/mp3"
                onChange={uploadVideoFile}/>

            <RaikoFlexAlignEnd className={css`gap: .5rem`}>
                {
                    videoFile &&
                    <RaikoButtonSecondary
                        label={"انتخاب ویدیو"}
                        onClick={handleSelectVideoFile}
                    />
                }
                {
                    videoFile &&
                    <RaikoButtonPrimary
                        label={"بارگزاری ویدیو"}
                        onClick={handleUploadVideo}
                    />
                }
                {
                    !videoFile &&
                    <RaikoButtonPrimary
                        label={"انتخاب مجدد ویدیو"}
                        onClick={handleSelectVideoFile}
                    />
                }
            </RaikoFlexAlignEnd>
        </div>
    )
}